import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { entrySearchSchema } from '../../../features/loyalty/search'
import { LoyaltyTransactionsPage } from '../../../features/loyalty/transactions-page'

export const Route = createFileRoute('/_app/loyalty/transactions')({
  staticData: { crumb: 'loyaltyTransactions' },
  validateSearch: entrySearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'loyalty.read'),
  component: LoyaltyTransactionsPage,
})
